// extracted by mini-css-extract-plugin
export default {"fixedBottomLeft":"modifiers_fixedBottomLeft__yYTcN","fixedBottomRight":"modifiers_fixedBottomRight__M+OBn","btnFix":"modifiers_btnFix__X22Dh"};